import React from 'react'
import { withIcon } from '../../withIcon'

function PlusSquaredIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M6 4.625C5.24061 4.625 4.625 5.24061 4.625 6V18C4.625 18.7594 5.24061 19.375 6 19.375H18C18.7594 19.375 19.375 18.7594 19.375 18V6C19.375 5.24061 18.7594 4.625 18 4.625H6ZM3.375 6C3.375 4.55025 4.55025 3.375 6 3.375H18C19.4497 3.375 20.625 4.55025 20.625 6V18C20.625 19.4497 19.4497 20.625 18 20.625H6C4.55025 20.625 3.375 19.4497 3.375 18V6ZM12 8.375C12.3452 8.375 12.625 8.65482 12.625 9V11.375H15C15.3452 11.375 15.625 11.6548 15.625 12C15.625 12.3452 15.3452 12.625 15 12.625H12.625V15C12.625 15.3452 12.3452 15.625 12 15.625C11.6548 15.625 11.375 15.3452 11.375 15V12.625H9C8.65482 12.625 8.375 12.3452 8.375 12C8.375 11.6548 8.65482 11.375 9 11.375H11.375V9C11.375 8.65482 11.6548 8.375 12 8.375Z" fill={color}/>
    </svg>
  )
}

export default withIcon(PlusSquaredIcon)
